import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function WithModelValue ({ name, defaultValue = null, children }) {
  const value = useValue(name, defaultValue)

  return children(value)
}
